module.exports = __webpack_public_path__ + "img/060_Mond_Mars.8c2601f0.jpg";